import Button from 'shared/Button';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Dialog from 'shared/Dialog';

interface SessionExpiredDialogProps extends Pick<
    ComponentProps<typeof Dialog>,
    'visible'
> {}

export default function SessionExpiredDialog(props: SessionExpiredDialogProps) {
    const navigate = useNavigate();

    const { t } = useTranslation('common');
    const { t: tLogin } = useTranslation('login');

    return (
        <Dialog
            // This modal is not closeable so hide its close (X) button
            className={'[&_button[aria-label="Close"]]:hidden'}
            size="sm"
            {...props}
        >
            <div className="pb-4">{t('errors.expired_session')}</div>
            <Button onClick={() => navigate(0)}>{tLogin('login')}</Button>
        </Dialog>
    );
}
